import { Navigate, Outlet } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '@/auth/AuthContext';

export default function AdminRoute() {
    const { role, isUserLoading } = useAuth();
    
    // Пока роль грузится — показываем спиннер, не редиректим
    if (isUserLoading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
                <CircularProgress sx={{ color: 'rgd.primary' }}/>
            </Box>
        );
    }
    
    // Если не админ — на главную
    if (role !== 'ADMIN') {
        return <Navigate to="/main" replace />;
    }
    
    return <Outlet />;
}